import { clinicColors, CLINIC_ACCENT } from '../pages/Clinic/clinicUi';

export const NFSE_STATUS_LABELS: Record<string, string> = {
  pending: 'Pendente',
  processando_autorizacao: 'Processando',
  autorizado: 'Autorizada',
  erro_autorizacao: 'Erro',
  cancelado: 'Cancelada',
};

export const NFSE_STATUS_COLORS: Record<string, string> = {
  pending: clinicColors.warning,
  processando_autorizacao: CLINIC_ACCENT,
  autorizado: clinicColors.positive,
  erro_autorizacao: clinicColors.negative,
  cancelado: clinicColors.slate,
};

export function nfseHasPdf(nf: { status?: string } | null | undefined): boolean {
  return Boolean(nf && ['autorizado', 'cancelado'].includes(nf.status || ''));
}

export function nfseCanRetry(nf: { status?: string } | null | undefined): boolean {
  const st = nf?.status || '';
  return st === 'erro_autorizacao' || st === 'pending';
}
